import React, { Component } from 'react';
import { getComments } from '../store/actions/fileActions.js'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import AuthHandlerInstance from '../Classes/AuthHandler'
import { postComment } from '../store/actions/poDetailsActions.js';
import FormatDateTimeInIST from '../Classes/FormatDateTimeInIST';
import { getDocumentVersions } from '../store/actions/fileActions.js';
import formatDate from '../Classes/FormatDateTimeInIST';
import Spinner from 'react-bootstrap/Spinner';
class DocumentCommentsPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comments: [],
            OpenModal: this.props.showCommentPopUp,
            uploadedId: this.props.uploadedId ? this.props.uploadedId : "",
            revisedPayload: this.props.revisedPayload,
            selectedfilestageIdVersion: [],//Keep documentTypeId
            stageIdsVersion: [], //
            fileUploadIds: [],//upload id
            purchaseLIneItemID: this.props.purchaseLIneItemID,
            purchaseOrderId: this.props.purchaseOrderId,
            writeComment: "",
        }
        this.OpenModalAction = this.OpenModalAction.bind(this);
        this.getComments = this.getComments.bind(this);
        this.dateformate = this.dateformate.bind(this);
        this.onSendComments = this.onSendComments.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    componentWillMount() {
        this.getComments();
    }

    dateformate(dateVal) {
        let d = new Date(dateVal);
        return d.toDateString();
    }

    async getComments() {
        if (this.state.uploadedId) {
            await this.props.getComments(this.state.uploadedId);
            let comments = this.props.comments && this.props.comments.results ? this.props.comments.results : [];
            console.log("comments", this.props.comments);
            this.setState({ comments });
        }
    }
    documentComments(st) {
        this.props.documentComments({}, this.state.uploadedId)
    }
    OpenModalAction(status) {
        if (status == false) {
            this.setState({ comments: [], uploadedId: "", OpenModal: false });
            this.props.documentComments(null);
        }
    }

    hChange = (e) => {
        let writeComment = this.state.writeComment
        writeComment = e.target.value;
        this.setState({ writeComment });
    }

    handleKeyPress = async (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.onSendComments()
            return false;
        }
    }
    async onSendComments() {
        console.log(this.state.revisedPayload, 'comment submit log')
        let comments = this.state.comments
        var roles = AuthHandlerInstance.getRoles()
        var IsSMS = 0
        var commentedBy = ""
        if (roles["5"]) {
            IsSMS = 0
            commentedBy = "Supplier"
        } else {
            IsSMS = 1
            commentedBy = "SMS"
        }
        let param = {
            purchaseLIneItemID: this.state.purchaseLIneItemID,
            purchaseOrderId: this.state.purchaseOrderId,
            stageDocumentId: this.state.revisedPayload.param.QADocumentId ? this.state.revisedPayload.param.QADocumentId : this.state.revisedPayload.param.QADocumentId,
            status: this.state.revisedPayload.param.status ? this.state.revisedPayload.param.status : this.state.revisedPayload.param.Status,
            uploadId: this.state.revisedPayload.param.uploadId ? this.state.revisedPayload.param.uploadId : this.state.revisedPayload.param.UploadId,
            comment: this.state.writeComment,
            DocumentTypeId: this.state.revisedPayload.param.documentTypeId ? this.state.revisedPayload.param.documentTypeId : this.state.revisedPayload.param.DocumentTypeId,
            IsSMS: IsSMS,
            commentedBy: commentedBy,
            actedBy: AuthHandlerInstance.getUserID()
        }

        console.log("to be sent", param)

        await this.props.postComment(param)

        this.state.writeComment = ""
        this.setState({ writeComment: this.state.writeComment })
        this.getComments()
    }

    render() {
        var roles = AuthHandlerInstance.getRoles()
        // console.log(this.props.comments.results,"@@@@@")
        console.log(this.props.uploadedId,"@@@@@")
        console.log(this.props.revisedPayload,"@@@@@")
        console.log(this.props.purchaseLIneItemID,"@@@@@")
        console.log(this.props.purchaseOrderId,"@@@@@")
        return (
            <Modal isOpen={this.state.OpenModal} >
                <div className={"modal-bg" + (this.props.OpenModal == true ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header">
                            <div className="modal-text"><h4 >Document comment/notes</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={(e) => this.OpenModalAction(false)} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                    <div>
                        <ModalBody Style="modal-body modalbodys">

                            <div className="row ">
                                <div className="col-8"></div>
                                <div className="col-4 pb-2">
                                    {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                                </div>
                            </div>

                            {this.state.comments && this.state.comments.length < 1 && <div className="row col-sm-12" style={{ textAlign: "center", display: "block", top: "40%" }}>
                                <Spinner animation="grow" role="status" variant="warning">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                                <div id="mydiv">Hey No Comments Yet !</div>
                            </div>}
                            <div>
                            </div>
                            {
                                this.state.comments && this.state.comments.map((item, i) => {
                                    let classValue = ""
                                    let color = ""
                                    { item.IsSMS == 1 ? classValue = "pl-4 ml-4 float-right" : classValue = "pr-4 mr-4 float-left" }
                                    { item.IsSMS == 1 ? color = "" : color = "#c8f5d8" }
                                    return <div className={classValue} >
                                        {item.Comments == "NA" ? null
                                            :
                                            <div className="row border border-radius-modal ml-2 mr-2 mt-2" style={{ backgroundColor: color }} >

                                                <div className="col-12" >
                                                    <div><h5>{item.DocumentName}</h5></div>

                                                    <div className=" row text-left">
                                                        <div className="col-12">Comment: {item.Comments}</div>
                                                        <div className="col-12 mb-2 mt-2">
                                                            <div className="row">
                                                                <div className="col">
                                                                    <div className="float-left" style={{ fontSize: "11px" }}>{FormatDateTimeInIST(item.DateTimeComments)}</div>
                                                                </div>
                                                                <div className="col">
                                                                    <div className="float-right" style={{ fontSize: "10px" }}>Commnted By : {item.CommentedBy}</div>
                                                                </div>
                                                            </div>
                                                            {/* <span className={"badge "+this.props.docStatus[item.Status]['badge']}>
                                                                    {this.props.docStatus[item.Status]['title']}
                                                            </span> */}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        }

                                    </div>
                                })
                            }
                        </ModalBody>
                    </div>
                    <div className="border" >
                        <ModalFooter >
                            <div className="row mt-2 mb-2 ml-2 mr-2">
                                <div className="col-sm-10 mt-2">
                                    <input type="text" className="form-control" placeholder="Enter Your Comment Here" value={this.state.writeComment} onChange={(e) => this.hChange(e)} onKeyPress={(e) => this.handleKeyPress(e)} />
                                </div>
                                <div className="col-sm-2 mt-1 pl-4">
                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"paper-plane"} color={"red"} title="send" size="2x" onClick={() => this.onSendComments()} />
                                </div>
                            </div>
                        </ModalFooter>
                    </div>
                </div>
            </Modal>

        )
    }
}


const mapStateToProps = (state) => ({
    comments: state.file.document_comments,
    comment: state.comment

})
export default connect(mapStateToProps, { getComments, postComment })(DocumentCommentsPopUp)
